import React, { FC, memo } from 'react';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { Card } from '@components/atoms/Card';
import { Anchor, AnchorMode } from '@components/atoms/Anchor';
import { SITE_URLS } from '@constants';
import styles from './PointsServiceCard.module.css';

export interface PointsServiceCardProps {
    uuid?: string;
    category?: string;
    name?: string;
    image?: string;
    pointsCost?: number;
}

export const PointsServiceCard: FC<PointsServiceCardProps> = memo(({ uuid, category, name, image, pointsCost }) => {
    return (
        <Card classes={styles.card}>
            <Anchor
                href={SITE_URLS.pointsServiceDetail.replace(':uuid', `${uuid}`)}
                classes="text-decoration-none"
                mode={AnchorMode.none}>
                <div className={`${styles.overlay} d-flex justify-content-between`}>
                    <div className={`${styles.points} align-content-center text-center bg-light`}>
                        <Typography tagVariant={TypographyTagVariants.span} fontSize="16" color="primary" fontWeight="700">
                            <>
                                <i className="fa-sharp fa-solid fa-trophy"></i> {pointsCost}
                            </>
                        </Typography>
                    </div>
                </div>
                <div>
                    <div className={`position-relative ${styles['card-sizing']}`}>
                        {image && <img src={image} className="card-img" alt={name} />}
                    </div>
                    <div className="card-body px-3 py-4">
                        <Typography classes="text-truncate text-uppercase mt-1 mb-3" color="primary" fontSize="12">
                            {category}
                        </Typography>
                        <Typography classes={`${styles.title} mb-1`} color="dark" fontWeight="900" fontSize="16">
                            <>{name}</>
                        </Typography>
                    </div>
                </div>
            </Anchor>
        </Card>
    );
});
